import React, { useEffect } from 'react'
import GrillaFacturasContainer from '../../components/organismos/GrillaFacturasContainer/GrillaFacturasContainer'
import {Titulo} from 'asocomponents'
import Layout from '../layouts/Layout'
import { useNavigate } from 'react-router-dom'
import FiltrosFacturasContainer from '../../components/organismos/FiltrosFacturasContainer/FiltrosFacturasContainer'

function GrillaFacturas() {
  const navigate = useNavigate()
  const redireccionar=()=>navigate('/loguin')  

  //Valido si el usuario esta logueado sino se lo redirecciona al loguin
  useEffect(() => {
    const usuarioGuardado = sessionStorage.getItem('usuario')
    if (!usuarioGuardado) {
      redireccionar()
    }
  }, [])

  return (
    <Layout>
      <Titulo titulo="Facturas Estudio"/>
      <FiltrosFacturasContainer />
      <GrillaFacturasContainer />
    </Layout>
  )
}

export default GrillaFacturas
